export const NotificationText = ({ notificationText }: NotificationTextProps) => {
    return <div className="notification-text" dangerouslySetInnerHTML={{ __html: notificationText }} />;
};

interface NotificationTextProps {
    notificationText: string;
}
